import { Box, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
// import { tokens } from "../../../../../theme";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Text from "../../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../../components/theme/buttons/Shbutton";

import { useTranslation } from "react-i18next";
import MpAddPickingCart from "../../../../../../../components/global/ModalsProgression/MpAddPickingCart/MpAddPickingCart";
import ShDataGrid2 from "../../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShTextSkeleton from "../../../../../../../components/theme/skeleton/ShTextSkeleton";
import { useFindAllPickupCartsQuery } from "../../../../../../../newapi/warehouse/pickupCartSlice";
import SidepanelLoader from "../../../../../../../components/theme/sidepanel2/SidepanelLoader";
import { selectUserPermission } from "../../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { generateColorFromTitle, generateIconColorFromTitle } from "../../../../../../../components/theme/TabView3/IconColorGenerator";
import WarehousePickingCartCard from "../../../../../../../components/global/cards/settings/WarehousePickingResourcesCards";

const SpPickingCartDetails = SidepanelLoader(() => import("../../../../../../../components/global/Sidepanels/SpPickingCartDetails/SpPickingCartDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    
    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_pickingcart")}</Shbutton>
            )}
        </ButtonGroup>
    )
}


const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};


const PickingCarts = (props,) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PICKINGRESOURCE_MANAGE])
    );

    const [pickingCartId, setpickingCartId] = useState();
    const pickingCartIdRef = useRef(pickingCartId);
    
    const getPickingCartDetails = (params) => {
        if (!params) return;
    
        const newpickingCartId = parseInt(params.row.id);
        // Only update state if the pickingCartId has actually changed
        if (pickingCartIdRef.current !== newpickingCartId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setpickingCartId(newpickingCartId);
            pickingCartIdRef.current = newpickingCartId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[props.warehouseModal]);
    
    
    const columns = [
        {field: "barcode", headerName: t("pickupcart") , flex:2, cellClassName: "stream", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text semibold>{cellValues.value}</Text>
            )
        }},
        {field: "reachType", headerName: t("reachtype"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }
            let backGround = generateColorFromTitle(cellValues.row.reachType?.description ?? "-", theme.palette.mode, 93)
            let foreGround = generateIconColorFromTitle(cellValues.row.reachType?.description ?? "-", theme.palette.mode)
            return (
                <Box
                    sx={{
                        height:32,
                        px:2,
                        display:"flex",
                        alignItems:'center',
                        fontFamily:"Roboto, sans-serif",
                        fontSize:14,
                        color:foreGround,
                        background:backGround,
                        border:`1px solid ${foreGround}`,
                        borderRadius:4,
                        fontWeight:500,
                    }}
                >
                    {cellValues.row.reachType?.description}
                </Box>
            )
        }},
        {field: "pickupCartLocations", headerName: t("locations"), flex:1,
            sortable:false,
             renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{cellValues.row.pickupCartLocations?.length ?? 0}</Text>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                
               return (
                <WarehousePickingCartCard 
                    skeleton={cellValues.row.skeleton ?? false}
                    {...cellValues.row}
                    onClick={() => getPickingCartDetails(cellValues)}
                />
               )
            }
        }
    ];


    const handleRowClick = (params) => {
        setIsExtended(true);
    };
    
    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
                <ShDataGrid2 key={theme.palette.mode}
                    content={useFindAllPickupCartsQuery}
                    gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                    title={t("overview")}
                    gridOptions={gridOptions} 
                    sortModel={{field: columns[0].field,type:"ASC"}}
                    columns={columns}
                    
                    onRowClick={getPickingCartDetails}>
                </ShDataGrid2>
            <MpAddPickingCart onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>

            {spLoading && 
                <SpPickingCartDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    pickingCartId={pickingCartId}
                    // data={pickupcartData}   
                /> 
            }
        </Box>
    )
};

export default PickingCarts;